import { useEffect, useCallback } from "react";

const useDebouncedEffect = (func: any, deps: any, delay?: number) => {
  const callback = useCallback(func, [func]);
  useEffect(() => {
    const handler = setTimeout(() => {
      callback();
    }, delay);

    return () => {
      clearTimeout(handler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, callback, delay]);
};

export default useDebouncedEffect;
